var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._t("shortForm",function(){return [_vm._v(_vm._s(_vm.title))]},{"value":_vm.title,"fullForm":_vm.fullForm,"hasFullForm":_vm.hasFullForm}),(_vm.showEllipsis)?_vm._t("ellipsis",function(){return [_c('ellipsis-tooltip',{attrs:{"value":_vm.fullForm}})]},{"value":_vm.fullForm}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }